/*
 * Bwè Manjé is a restaurant table booking application on the Android Platform.
 *
 * Copyright (C) 2020-2025 by Frédéric-Charles Barthéléry.
 *
 * This file is part of Bwè Manjé.
 */
package com.geekorum.rdv.bwemanje.accountdeletion

import androidx.compose.runtime.*
import firebase.auth.Auth
import js.firebaseui.AuthUI
import js.firebaseui.Config
import kotlinx.coroutines.await
import kotlinx.coroutines.channels.awaitClose
import kotlinx.coroutines.flow.callbackFlow
import kotlinx.js.jso
import org.jetbrains.compose.web.dom.*

internal fun Auth.currentUserFlow() = callbackFlow {
    val unsubscribe = onAuthStateChanged { user ->
        trySend(user)
    }
    awaitClose {
        unsubscribe()
    }
}


@Composable
fun SignInSection(
    authUi: AuthUI,
    config: Config,
    onSignInSuccess: (String?) -> Unit,
) {
    var isLoading by remember { mutableStateOf(true)}

    val actualConfig = remember(config) {
        config.apply {
            callbacks = jso {
                signInSuccessWithAuthResult = { authResult, successUrl ->
                    onSignInSuccess(successUrl)
                    false
                }
                uiShown = { isLoading = false }
            }
        }
    }

    Section(
        { id("firebaseui-auth-container") }
    ) {
        if (isLoading) {
            Div({ classes("loading-container") }) {
//                MdcCircularProgress()
                Span({ classes() }) { Text(("Connexion en cours")) }
            }
        }
        DisposableEffect(Unit) {
            authUi.start(scopeElement, actualConfig)
            onDispose { }
        }
    }
}
